import * as React from 'react';
import { Dispatch } from 'react';
import { CheckinOrderFragment, CheckoutOrderFragment, OrderSelectedServices } from '@websky/graphql';
import { useTransferService } from './model';
import TransferSelector from '../TransferSelector/TransferSelector';
import { useTheme } from '../../../theme';
import { SegmentId } from '../../../types';

interface Props {
	order: CheckoutOrderFragment | CheckinOrderFragment;
	onChange: Dispatch<OrderSelectedServices>; // стейт к сохранению сервисов ( совместим как с авиа заказом так и с чекином )
	onStateChanged: Dispatch<boolean>; // просто флаг указывающий на то, что изначальный стейт изменен
	activeSegment?: SegmentId;
}

const TransferService: React.FC<Props> = ({ order, onChange, activeSegment, onStateChanged }) => {
	const model = useTransferService(order, onChange, onStateChanged, activeSegment);
	const { TransferService: css } = useTheme('Transfer');

	return (
		<div className={css.container}>
			{model.activeSegmentServices.map(service => {
				return (
					<TransferSelector
						isSelected={model.selectedServices.has(service.id)}
						key={service.id}
						passengers={model.passengersById}
						onChange={model.onChangeService}
						segments={model.segmentsById}
						service={service}
						servicesState={model.services}
						isOpen={model.activeService === service.id}
						onOpen={model.setActiveService}
						onClose={() => model.setActiveService(null)}
					/>
				);
			})}
		</div>
	);
};

export default TransferService;
